/* BRAINGAIN Klarna payment pill — EU + UK. Requires the global Liquid section.
 * Eligibility uses selected Shopify country, never language or IP guessing.
 * Keep the verified country list in the theme editor aligned with checkout.
 */
(function () {
  'use strict';
  if (window.__braingainKlarnaPillV2) return;
  if (!['eu.braingain.fit', 'braingain.fit', 'www.braingain.fit'].includes(window.location.hostname)) return;
  window.__braingainKlarnaPillV2 = true;

  const CONFIG = {
    productLineId: 'klarna-payment-pill-product-line',
    cartLineId: 'klarna-payment-pill-cart-line',
    styleId: 'klarna-payment-pill-style'
  };
  const LOCALES = { en: 'en-IE', fr: 'fr-FR', de: 'de-DE', it: 'it-IT', es: 'es-ES' };
  const COPY = {
    en: ['Pay in 3 monthly payments of ', ' with'],
    fr: ['Payez en 3 mensualités de ', ' avec'],
    de: ['Bezahle in 3 Raten von ', ' mit'],
    it: ['Paga in 3 rate da ', ' con'],
    es: ['Paga en 3 plazos de ', ' con']
  };
  let queued = false;
  let interactionTimer;

  function readContext() {
    const nodes = document.querySelectorAll('[data-braingain-klarna-config]');
    try {
      return JSON.parse(nodes[nodes.length - 1].textContent);
    } catch (_) {
      return null; // No Liquid context: do not guess eligibility.
    }
  }

  function countries(value) {
    return String(value || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
  }

  function eligible(context) {
    if (!context || !/^[A-Z]{2}$/.test(context.country || '')) return false;
    if (!['EUR', 'GBP'].includes(context.currency)) return false;
    if (countries(context.excludedCountries).includes(context.country)) return false;
    if (context.eligibilityMode === 'verified') {
      return countries(context.verifiedCountries).includes(context.country);
    }
    return context.eligibilityMode === 'automatic' &&
      Array.isArray(context.paymentTypes) && context.paymentTypes.some(function (type) {
        return /^klarna(?:_|$)/i.test(String(type));
      });
  }

  function language(context) {
    const code = String(context.language || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return COPY[code] ? code : 'en';
  }

  // Read only prices bearing the active currency; the final price in ATC copy
  // is the live total including add-ons, matching the original implementation.
  // Return integer cents so floating point cannot add an erroneous extra cent.
  function extractCents(text, currency) {
    const expression = currency === 'GBP'
      ? /(?:£|GBP)\s*\d[\d\s.,'’]*|\d[\d\s.,'’]*\s*(?:£|GBP)/gi
      : /(?:€|EUR)\s*\d[\d\s.,'’]*|\d[\d\s.,'’]*\s*(?:€|EUR)/gi;
    const matches = String(text || '').match(expression);
    if (!matches) return null;
    let value = matches[matches.length - 1].replace(/EUR|GBP|[€£\s'’]/gi, '');
    const separator = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    let fraction = '';
    if (separator >= 0 && value.length - separator - 1 <= 2) {
      fraction = value.slice(separator + 1);
      value = value.slice(0, separator);
    }
    const whole = value.replace(/[.,]/g, '');
    if (!/^\d+$/.test(whole) || !/^\d{0,2}$/.test(fraction)) return null;
    const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return Number.isSafeInteger(cents) ? cents : null;
  }

  function formatInstalment(cents, context) {
    const amount = Math.ceil(cents / 3) / 100;
    const locale = language(context);
    const formatted = amount.toLocaleString(context.currency === 'GBP' && locale === 'en' ? 'en-GB' : LOCALES[locale], {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    return context.currency === 'GBP' ? '£' + formatted : formatted + '\u00a0€';
  }

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) return;
    const style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent = `
      #${CONFIG.productLineId},
      #${CONFIG.cartLineId} {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        box-sizing: border-box !important;
        color: #171717 !important;
        background: #fff5fa !important;
        border: 2px solid #ffaad0 !important;
        border-radius: 999px !important;
        font-weight: 600 !important;
        line-height: 1.25 !important;
        text-align: center !important;
        clear: both !important;
      }

      #${CONFIG.productLineId} {
        width: fit-content !important;
        max-width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 15px !important;
        padding: 7px 15px !important;
        font-size: 13px !important;
      }

      #${CONFIG.cartLineId} {
        width: 100% !important;
        justify-content: center !important;
        margin: 8px 0 10px 0 !important;
        padding: 7px 12px !important;
        font-size: 13px !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-badge,
      #${CONFIG.cartLineId} .klarna-payment-pill-badge {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        background: #ff9ccc !important;
        color: #111 !important;
        border-radius: 7px !important;
        padding: 6px 12px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-3x,
      #${CONFIG.cartLineId} .klarna-payment-pill-3x {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        width: 28px !important;
        height: 28px !important;
        border-radius: 50% !important;
        background: #ffb3d5 !important;
        color: #111 !important;
        font-weight: 700 !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-copy,
      #${CONFIG.cartLineId} .klarna-payment-pill-copy {
        white-space: nowrap !important;
      }

      @media (max-width: 480px) {
        #${CONFIG.productLineId} {
          width: 100% !important;
          font-size: 11px !important;
          padding: 6px 8px !important;
          gap: 4px !important;
          justify-content: flex-start !important;
        }

        #${CONFIG.cartLineId} {
          font-size: 11px !important;
          gap: 4px !important;
          padding: 7px 8px !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-copy,
        #${CONFIG.cartLineId} .klarna-payment-pill-copy {
          white-space: normal !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
          text-align: left !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-3x,
        #${CONFIG.cartLineId} .klarna-payment-pill-3x {
          width: 23px !important;
          height: 23px !important;
          min-width: 23px !important;
          font-size: 10px !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-badge,
        #${CONFIG.cartLineId} .klarna-payment-pill-badge {
          padding: 4px 7px !important;
          font-size: 11px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function priceBlock() {
    return document.querySelector('.product-description .product-info__block.product-price') ||
      document.querySelector('.product-description .product-price') ||
      document.querySelector('.product-info__block.product-price') ||
      document.querySelector('main .product-price');
  }

  function productTotal(block, context) {
    const root = block.closest('product-info, .product-info, .product') || document.querySelector('main') || document;
    const atc = root.querySelector('product-form button[name="add"]') ||
      root.querySelector('form.js-product-form-main button[name="add"]') ||
      root.querySelector('.product-info__add-button button[name="add"]') ||
      root.querySelector('button[name="add"]');
    if (atc) {
      const total = extractCents(atc.textContent, context.currency);
      if (total !== null) return total;
    }
    const price = block.querySelector('.price__default .price__current') || block.querySelector('.price__current');
    return price ? extractCents(price.textContent, context.currency) : null;
  }

  function removeLine(id) {
    const line = document.getElementById(id);
    if (line) line.remove();
  }

  function updateLine(id, total, context) {
    injectStyles();
    let line = document.getElementById(id);
    if (!line) {
      line = document.createElement('div');
      line.id = id;
      line.setAttribute('aria-live', 'polite');
      line.setAttribute('aria-atomic', 'true');
      [['3x', '3×'], ['copy', ''], ['badge', 'Klarna']].forEach(function (entry) {
        const span = document.createElement('span');
        span.className = 'klarna-payment-pill-' + entry[0];
        span.textContent = entry[1];
        line.appendChild(span);
      });
    }
    const copy = COPY[language(context)];
    const message = copy[0] + formatInstalment(total, context) + copy[1];
    const target = line.querySelector('.klarna-payment-pill-copy');
    // Avoid rewriting unchanged DOM: the original observer could loop forever.
    if (target.textContent !== message) target.textContent = message;
    return line;
  }

  function renderProduct(context) {
    if (context.pageType !== 'product') {
      removeLine(CONFIG.productLineId);
      return;
    }
    const block = priceBlock();
    const total = block ? productTotal(block, context) : null;
    if (!block || total === null || total <= 0) {
      removeLine(CONFIG.productLineId);
      return;
    }
    let placeholder = document.querySelector('[data-klarna-payment-pill-product]');
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.id = 'klarna-payment-pill-product';
      placeholder.className = 'klarna-payment-pill-product-placeholder';
      placeholder.setAttribute('data-klarna-payment-pill-product', '');
    }
    if (block.nextElementSibling !== placeholder) block.insertAdjacentElement('afterend', placeholder);
    const line = updateLine(CONFIG.productLineId, total, context);
    if (line.parentElement !== placeholder) placeholder.appendChild(line);
  }

  function renderCart(context) {
    const checkout = document.querySelector('#lcu__drawer-checkout');
    const group = document.querySelector('.lcu__drawer__cta-group') || (checkout && checkout.parentElement);
    const footer = document.querySelector('.lcu__drawer__footer-buttons');
    const node = document.querySelector('.lcu-summary-final-total') ||
      document.querySelector('.lcu__drawer__subtotal .lcu__product-price') ||
      document.querySelector('.lcu__drawer__footer .lcu__product-price');
    const total = node ? extractCents(node.textContent, context.currency) : null;
    if (!group || !footer || total === null || total <= 0) {
      removeLine(CONFIG.cartLineId);
      return;
    }
    const line = updateLine(CONFIG.cartLineId, total, context);
    if (line.nextElementSibling !== group) group.insertAdjacentElement('beforebegin', line);
  }

  function render() {
    queued = false;
    const context = readContext();
    if (!eligible(context)) {
      removeLine(CONFIG.productLineId);
      removeLine(CONFIG.cartLineId);
      return;
    }
    renderProduct(context);
    renderCart(context);
  }

  function queueRender() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(render);
  }

  function init() {
    // Includes text-node updates, variant swaps, and complete drawer replacement.
    new MutationObserver(queueRender).observe(document.body, {
      childList: true, characterData: true, subtree: true
    });
    ['change', 'input', 'click', 'variant:change', 'cart:updated', 'shopify:section:load', 'shopify:section:unload'].forEach(function (event) {
      document.addEventListener(event, function () {
        queueRender();
        clearTimeout(interactionTimer);
        interactionTimer = setTimeout(queueRender, 300);
      });
    });
    queueRender();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
